import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form"];

  // Funcion que se ejecuta cuando inicia la pagina correspondiente donde se encuentra el controller.js
  connect() {}

  // enableBtn() {
  //   console.log(this.formTarget);
  //   if (this.formTarget) {
  //     const button = document.querySelector("#nextBtn");
  //     button.disabled = true;
  //   }
  // }
}
